// server/browser/src/main.ts
import { mount } from "svelte";

import App from "./App.svelte";
import "./app.css";
import { APP_NAME, TAGLINE } from "./lib/brand";

// index.html ships a brand-neutral title; set the real one from the staged
// brand so the tab reads correctly for whichever brand this bundle is.
document.title = `${APP_NAME} — ${TAGLINE}`;

const target = document.getElementById("app");
if (!target) {
  throw new Error("#app mount point not found in index.html");
}

const app = mount(App, { target });

export default app;
